import React from 'react';
import { MetricBadgeValue } from './calculatorEstimates';
import { useCmpOrganizationNoun } from '../../../contexts/CmpOrganizationNounContext';
import { applyCmpOrganizationNoun } from '../../../utils/cmpOrganizationNoun';

export default function MetricBadge({ value }: { value: MetricBadgeValue | null }) {
  const noun = useCmpOrganizationNoun();
  if (!value) return null;
  return <span className="inline-flex shrink-0 flex-col items-center gap-1">
    <span className="inline-flex items-center gap-[7px] whitespace-nowrap rounded-full px-3 py-[5px] text-[12px] font-bold text-white" style={{ backgroundColor: value.color }}>
      <span aria-hidden="true" className="h-[7px] w-[7px] rounded-full bg-white" />{value.label}
    </span>
    <span className="text-[11px] text-[#0A0A0A]">{applyCmpOrganizationNoun(value.note, noun)}</span>
  </span>;
}
